export const API_ROOT = '/'

export const AUTH_OBTAIN_TOKEN = API_ROOT + 'token/'
export const AUTH_REFRESH_TOKEN = API_ROOT + 'token/refresh/'
export const PASSWORD_RESET_REQUEST = API_ROOT + 'password-reset/'
export const PASSWORD_RESET_VALIDATE = API_ROOT + 'password-reset/validate_token/'
export const PASSWORD_RESET_CONFIRM = API_ROOT + 'password-reset/confirm/'
export const ME = API_ROOT + 'teams/me/'
export const TEAMS = API_ROOT + 'teams/teams/'
export const TEAM_COLLECTIONS = API_ROOT + 'teams/team-collections/'
export const PARTIAL_ACCOUNT_SETUPS = API_ROOT + 'teams/partial-account-setups/'
export const SHARED_TEAM_COLLECTIONS = API_ROOT + 'teams/shared-collections/'
export const FAVOURITE_TRACKS = API_ROOT + 'teams/favourite-tracks/'
export const PLAN_CHANGE_REQUESTS = API_ROOT + 'teams/plan-change-requests/'
export const ORDERS = API_ROOT + 'licensing/orders/'
export const PRODUCTS = API_ROOT + 'licensing/products/'
export const LICENSES = API_ROOT + 'licensing/licenses/'
export const LICENSING_INVOICES = API_ROOT + 'licensing/invoices/'
export const TRACKS = API_ROOT + 'catalogue/tracks/'
export const TRACK_SEARCH = API_ROOT + 'catalogue/search-tracks-es/'
export const TRACK_SEARCH_NL = API_ROOT + 'catalogue/search-tracks-nl/'
export const TRACK_SEARCH_OPTIONS = API_ROOT + 'catalogue/track-search-options/'
export const SFX_SEARCH = API_ROOT + 'catalogue/search-sfx/'
export const SFX_PSE_SEARCH = API_ROOT + 'catalogue/search-sfx-pse/'
export const SFX_PSE_DOWNLOAD = API_ROOT + 'catalogue/download-sfx-pse/'
export const SFX_PSE_DOWNLOAD_LOG = API_ROOT + 'sfx-downloads/pse/'
export const ARTISTS = API_ROOT + 'catalogue/artists/'
export const ARTIST_SEARCH = API_ROOT + 'catalogue/search-artists-es/'
export const RELEASES = API_ROOT + 'catalogue/releases/'
export const WAVEFORMS = API_ROOT + 'catalogue/waveforms/'
export const PLAYLISTS = API_ROOT + 'catalogue/playlists/'
export const KEYWORD_LANDING_PAGES = API_ROOT + 'keyword-landing-pages/'
export const PLAYLIST_SEARCH = API_ROOT + 'catalogue/search-playlists-es/'
// Picks from the tracks page search box, for analytics.
export const SEARCH_BOX_SELECTIONS = API_ROOT + 'analytics/search-box-selections/'
export const SHARED_PLAYLISTS = API_ROOT + 'catalogue/shared-playlists/'
export const SUBSCRIPTIONS = API_ROOT + 'subscriptions/subscriptions/'
export const SUBSCRIPTION_INVOICES = API_ROOT + 'subscriptions/invoices/'
export const PLANS = API_ROOT + 'subscriptions/plans/'
export const PAYMENT_DETAILS = API_ROOT + 'payment-details/'
export const WAFFLE = API_ROOT + 'waffle/'
